export default __webpack_public_path__ + "static/media/keto_thirst@3x.3807d31d.jpg";